import { useTranslation } from '@fanfanlo';
import { PermissionCommonDanger, PermissionCommonName, PermissionCommonNotPass, PermissionCommonPass, PermissionCommonSetting } from '../components/Components';
import { useEffect, useState } from 'react';
import { floatingInfo } from '@droid/android';
import { tabActivity } from '@fanfanlo';
export function FloatingInfo(){
    const {t} = useTranslation('homepage/components/permissions/floating/content');
    const [hasPermission, setHasPermission] = useState(floatingInfo.hasPermission());
    useEffect(()=>{
        const unlisten = tabActivity.listen((activity)=>{
            setHasPermission(floatingInfo.hasPermission());
        })  
        return ()=>{
            unlisten();
        }
    }, []);
    return <div>
        <PermissionCommonName>{t('FloatingInfo.name')}</PermissionCommonName>
        <span onClick={()=>{
            floatingInfo.openPermission();
        }}>
            <PermissionCommonSetting />
        </span>
        {hasPermission ? <PermissionCommonPass/> : <PermissionCommonNotPass/>}
        <PermissionCommonDanger desc={t('FloatingInfo.dangerDesc')} />
    </div>
}
